module.exports = __webpack_public_path__ + "mobile/img/icon_home_nav_logo1.f9f5aee3.png";